'use client';

import * as React from 'react';
import { cva } from 'class-variance-authority';
import { OTPInput, OTPInputContext } from 'input-otp';
import { cn } from '@/shared/lib/classnames/cn';
import inputsIcon from '@/shared/assets/sprites/inputs.sprite.svg';
import type { VariantProps } from 'class-variance-authority';
const slotVariants = cva('relative mx-2 flex h-20 w-16 items-center justify-center rounded-2xl text-lg font-bold transition-all', {
  variants: {
    variant: {
      default: 'bg-bgSecondary',
      // border просто с опасити 10
      success: 'border-2 border-statusSuccess bg-[#5EC0211A]',
      error: 'border-2 border-statusError bg-[#EC55551A]'
    }
  },
  defaultVariants: {
    variant: 'default'
  }
});
const InputOTP = React.forwardRef<React.ElementRef<typeof OTPInput>, React.ComponentPropsWithoutRef<typeof OTPInput>>(({
  className,
  containerClassName,
  ...props
}, ref) => <OTPInput autoFocus inputMode="numeric" ref={ref} containerClassName={cn('flex items-center gap-2 has-[:disabled]:opacity-50', containerClassName)} className={cn('disabled:cursor-not-allowed', className)} {...props} />);
InputOTP.displayName = 'InputOTP';
const InputOTPGroup = React.forwardRef<React.ElementRef<'div'>, React.ComponentPropsWithoutRef<'div'>>(({
  className,
  ...props
}, ref) => <div ref={ref} className={cn('flex items-center', className)} {...props} />);
InputOTPGroup.displayName = 'InputOTPGroup';
const InputOTPSlot = React.forwardRef<React.ElementRef<'div'>, React.ComponentPropsWithoutRef<'div'> & {
  index: number;
  autoFocus?: boolean;
} & VariantProps<typeof slotVariants>>(({
  index,
  className,
  variant,
  autoFocus,
  ...props
}, ref) => {
  const inputOTPContext = React.useContext(OTPInputContext);
  const {
    char,
    hasFakeCaret,
    isActive
  } = inputOTPContext.slots[index];
  const focusable = autoFocus && !char;
  return <div ref={ref} className={cn(slotVariants({
    variant,
    className
  }), (isActive || focusable) && 'z-10 border-2 border-primary')} {...props}>
      {char}
      {hasFakeCaret && <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
          <div className="bg-foreground h-4 w-px animate-caret-blink duration-1000" />
        </div>}
    </div>;
});
InputOTPSlot.displayName = 'InputOTPSlot';
const InputOTPSeparator = React.forwardRef<React.ElementRef<'div'>, React.ComponentPropsWithoutRef<'div'>>(({
  ...props
}, ref) => <div ref={ref} role="separator" {...props}>
      <svg>
        <use xlinkHref={`${inputsIcon}#dot`} />
      </svg>
    </div>);
InputOTPSeparator.displayName = 'InputOTPSeparator';
export { InputOTP, InputOTPGroup, InputOTPSlot, InputOTPSeparator };